import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';

import { SpinnerService } from '@core/services';
import { SpinnerComponent } from '@ui/shared';

@Component({
    selector: 'app-root',
    standalone: true,
    templateUrl: './root.component.html',
    styleUrl: './root.component.scss',
    imports: [
        CommonModule, 
        RouterOutlet,
        SpinnerComponent
    ],
})
export class RootComponent {

    title = 'hdesk';

    constructor(public spinner: SpinnerService) {}
}
